export default (
  state = {
    accounts: [],
    allPriceLists: [],
    pipelineOpportunities: [],
    opportunities: [],
    opportunityStages: [],
    documentTypes: [],
    opportunityByID: null,
  },
  action,
) => {
  switch (action.type) {
    /*
    ===============================
        Pipeline Init Data
    ===============================
    */
    case "PIPELINE_INIT_DATA":
      return {
        ...state,
        opportunities: action.payload.newOpps,
        accounts: action.payload.response[1].Accounts,
        opportunityStages: action.payload.response[2],
        documentTypes: action.payload.response[3],
        pipelineOpportunities: action.payload.pipelineData,
      };
    case "OPPORTUNITIES_BY_ID":
      return {
        ...state,
        opportunityByID: action.payload,
      };
    /*
    ===============================
        Pipeline Opportunities
    ===============================
    */
    case "PIPELINE_OPPORTUNITIES_DATA":
      return {
        ...state,
        pipelineOpportunities: action.payload,
      };

    case "PIPELINE_FILTERED_OPPORTUNITIES_DATA":
      return {
        ...state,
        pipelineOpportunities: action.payload.pipelineData,
        opportunities: action.payload.opportunities,
      };

    /*
    ===============================
        Delete Document 
    ===============================
    */
    case "DELETE_DOCUMENT":
      return {
        ...state,
        pipelineOpportunities: action.payload.pipelineData,
        opportunities: action.payload.opportunities,
      };
    /*
    ===============================
        Update Individual keys 
    ===============================
    */
    case "UPDATE_ACCOUNTS":
      return {
        ...state,
        accounts: action.payload,
      };
    case "UPDATE_OPPORTUNITIES":
      return {
        ...state,
        opportunities: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/PipelineReducer.js